import { render, staticRenderFns } from "./FirmInvoicePanel.vue?vue&type=template&id=a4a8a0c8&"
import script from "./FirmInvoicePanel.vue?vue&type=script&lang=js&"
export * from "./FirmInvoicePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports